var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"DeviceMap"},[_c('map-control',{attrs:{"locations":_vm.locations,"styles":"height: 100%; z-index: 0;"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }